import React from 'react';
import Grid from '@material-ui/core/Grid';
import { ResetEmailSuccess } from '../components';
import { withRouter } from 'react-router-dom';
import '../../../assets/styles/auth-module.scss';

function UserAuthThanks(props) {
  return (
    <section className="user-authentication-section">
      <Grid
        container
        spacing={0}
        alignItems="center"
        justify="center"
        className="user-form-wrapper auth-thanks"
        style={{ height: window.innerHeight - 80 }}
      >
        <ResetEmailSuccess />
      </Grid>
    </section>
  );
}
export default withRouter(UserAuthThanks);
